import api from '../..'

const getParticipant = (id: number) => {
  return api.get(`administration/users/${id}`)
}

export default getParticipant
